module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/41880799fe091bc1302b42c64710352a.svg";